import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from 'ngx-intl-tel-input';
import { Country } from 'ngx-intl-tel-input/lib/model/country.model';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.less'],
})
export class PhoneInputComponent implements OnInit {
  phoneInitiated: boolean = false;

  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() cssClass: string;
  @Input() preferredCountries: Array<CountryISO> = [];
  @Input() onlyCountries: Array<CountryISO> = [];
  @Input() enableAutoCountrySelect: boolean = true;
  @Input() enablePlaceholder: boolean = true;
  @Input() customPlaceholder: string;
  @Input() numberFormat: PhoneNumberFormat = PhoneNumberFormat.International;
  @Input() searchCountryFlag: boolean = false;
  @Input() searchCountryField: Array<SearchCountryField> = [];
  @Input() searchCountryPlaceholder: string = 'Search Country';
  @Input() maxLength: Number;
  @Input() selectFirstCountry: boolean = true;
  @Input() phoneValidation: boolean = true;
  @Input() selectedCountryISO: Array<CountryISO> = [];
  @Input() separateDialCode: boolean = true;

  @Output()
  onCountryChange: EventEmitter<Country> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onChangePhone(phoneNumber) {
    // TODO review the component NgxIntlTelInput - consider building our own component
    if (!this.phoneInitiated) {
      this.formGroup.get(this.controlName).markAsPristine();
      this.phoneInitiated = true;
    }
  }
}
